/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dd_weekend = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekend days`)
};

const es_dd_weekend = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Días de fin de semana`)
};

const de_dd_weekend = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wochenendtage`)
};

const nl_dd_weekend = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekenddagen`)
};

const fr_dd_weekend = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jours de fin de semaine`)
};

const it_dd_weekend = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giorni del fine settimana`)
};

const pt_br2_dd_weekend = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dias de fim de semana`)
};

const pt_dd_weekend = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dias de fim de semana`)
};

const ja_dd_weekend = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`週末日`)
};

const zh_dd_weekend = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`周末天数`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dd_weekend = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dd_weekend(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dd_weekend", locale)
	if (locale === "en") return en_dd_weekend(inputs)
	if (locale === "es") return es_dd_weekend(inputs)
	if (locale === "de") return de_dd_weekend(inputs)
	if (locale === "nl") return nl_dd_weekend(inputs)
	if (locale === "fr") return fr_dd_weekend(inputs)
	if (locale === "it") return it_dd_weekend(inputs)
	if (locale === "pt-BR") return pt_br2_dd_weekend(inputs)
	if (locale === "pt") return pt_dd_weekend(inputs)
	if (locale === "ja") return ja_dd_weekend(inputs)
	return zh_dd_weekend(inputs)
};